import { render, staticRenderFns } from "./DocumentCategoryAllActivities.vue?vue&type=template&id=058604b9"
import script from "./DocumentCategoryAllActivities.vue?vue&type=script&lang=ts"
export * from "./DocumentCategoryAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports